module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a16550bba935c0274be.worker.js");
};


// WEBPACK FOOTER //
// ./src/app/workers/SalesDataProcessor.worker.js